import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import LdsButton from "../../components/LdsButton";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";
import LdsImage from "../../components/LdsImage";
import References from "../../components/References";
import FigureCaption from "../../components/LdsFigureCaption";
import NegativeScan from "../../assets/module-1/1-1-2-negative-transverse.jpg";
import PositiveScan from "../../assets/module-1/1-1-2-positive-transverse.jpg";

// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";

const Module_1_1_2 = () => {
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);

  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} />}
      <div className="col-sm-8">
        <main>
          <section className="mb-5">
            <h1 className="blue text-uppercase b mt-5">
              1.1.2 Amyvid: Mechanism of Action
            </h1>
            <p className="mt-3 mb-0">Estimated time to complete: 1 minute</p>
          </section>
          <section className="mb-5">
            <h1 className="h5 b">White Matter Binding</h1>
            <p>
              The determination of cortical uptake of Amyvid relies on
              inspection of the contrast between gray matter and white matter.
              <sup>1-3</sup>
            </p>
            <div className="content-container blue-rounded-border mt-4">
              <h2 className="h3 b text-center mt-3 mb-3">Amyvid Scans</h2>
              <div className="row">
                <div className="col-sm-12 col-md-6 p-5">
                  <FigureCaption
                    noCollapse={true}
                    className="figcaption-no-border align-items-center flex-column d-flex"
                    textContent={
                      <>
                        <p className="text-center">
                          &copy;2016. Avid Radiopharmaceuticals, Inc. All rights reserved.
                          Data on File, Lilly Research Laboratories: AMY20121001A.
                        </p>
                      </>
                    }
                  >
                    <LdsImage
                      src={NegativeScan}
                      alt="Negative Amyvid brain scan showing no significant presence of amyloid plaques."
                      style={{ maxWidth: "250px" }}
                      className=""
                    />
                  </FigureCaption>
                  <p className="text-center">
                    Amyvid is routinely visible in white matter, but binding in
                    cortical gray matter is very low or absent in individuals
                    for whom β-amyloid plaques are none or sparse.
                    <sup>2.3</sup>
                  </p>
                </div>
                <div className="col-sm-12 col-md-6 p-5">
                  <FigureCaption
                    noCollapse={true}
                    className="figcaption-no-border align-items-center flex-column d-flex"
                    textContent={
                      <>
                        <p className="text-center">
                          &copy;2016. Avid Radiopharmaceuticals, Inc. All rights
                          reserved.Data on File, Lilly Research Laboratories:
                          AMY20121001B.
                        </p>
                      </>
                    }
                  >
                    <LdsImage
                      src={PositiveScan}
                      alt="Positive Amyvid brain scan showing presence of amyloid plaques.”"
                      style={{ maxWidth: "250px" }}
                      className=""
                    />
                  </FigureCaption>
                  <p className="text-center">
                    If β-amyloid plaques are moderate or frequent, the
                    amyloid image contrast between gray and white is greatly
                    reduced or visually undetectable.<sup>1-3</sup>
                  </p>
                </div>
              </div>
            </div>
          </section>
          <section className="button-control">
            <LdsButton
              classes="white-button mt-3 mb-5 prev"
              onClick={function navClick() {
                window.open("/module-1/module-1-1-1", "_self");
              }}
            >
              Previous Lesson
            </LdsButton>
            <LdsButton classes="blue-button mt-3 mb-5 align-self-right float-end next" onClick={function navClick() { window.open("/module-1/module-1-2-1", "_self") }}>
              Next Lesson
            </LdsButton>
          </section>
          <References>
            <ol className="no-indent fz-sm">
              <li>
                Amyvid (florbetapir F 18 injection) Prescribing Information.
                Lilly USA, LLC.
              </li>
              <li>
                Wong DF, et al. <em>J Nucl Med.</em> 2010;51(6):913-920.
              </li>
              <li>
                Johnson KA, et al. <em>Alzheimers Dement.</em> 2013;9(1):e1-e16.
              </li>
            </ol>
          </References>
        </main>
      </div>
    </div>
  );
};

export default Module_1_1_2;
